/**
 * PATH: packages/email-hub/src/feature/components/email-allocation/AllocationAvatar.tsx
 * FILE_ID: EMAILHUB-ALLOCATION-AVATAR-001
 * PURPOSE: Shared avatar leaf for assignment and watcher controls.
 */
import { cn } from '../../../_internal/lib/utils'
import { allocationInitials } from './helpers'

interface AllocationAvatarProps {
  name?: string | null
  email?: string | null
  avatar_url?: string | null
  size?: 'xs' | 'sm'
}

export function AllocationAvatar({
  name,
  email,
  avatar_url,
  size = 'sm',
}: AllocationAvatarProps) {
  const dims = size === 'xs' ? 'h-5 w-5 text-[9px]' : 'h-6 w-6 text-[10px]'
  if (avatar_url) {
    return (
      <img
        src={avatar_url}
        alt={name || email || ''}
        className={cn(
          dims,
          'rounded-full object-cover border border-border bg-muted',
        )}
      />
    )
  }
  return (
    <div
      className={cn(
        dims,
        'rounded-full flex items-center justify-center font-medium',
        'bg-gradient-to-br from-indigo-500/20 to-violet-500/20 text-foreground/80 border border-border',
      )}
      aria-label={name || email || 'unknown'}
    >
      {allocationInitials(name, email)}
    </div>
  )
}
